import {lazy} from 'react';

export default [
    {
        label: '',
        key: 'OnlineSeminar',
        path: '/online-seminar',
        element: lazy(() => import('@/components/Layout/CommonLayout')),
        children: [
            {
                label: '华为云直播研讨会过渡页',
                key: 'online-seminar-transition',
                path: 'transition/:businessId',
                element: lazy(() => import('@/page/OnlineSeminar/Transition')),
                show: false
            },
            {
                label: '华为云直播研讨会页',
                key: 'online-seminar-meeting',
                path: 'meeting/:businessId',
                element: lazy(() => import('@/page/OnlineSeminar/Meeting')),
                show: false
            }
        ]
    }
];
